import axios from 'axios';

export default {
	
	pre_insertar_sinliq(p_email, p_usuario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_garseguimiento.pre_insercion_sinliq",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario
				  })
			})
	},

	pre_insertar_enproceso(p_email, p_usuario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_garseguimiento.pre_insercion_enproceso",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario
				  })
			})
	},

	pre_insertar_sincob(p_email, p_usuario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_garseguimiento.pre_insercion_sincob",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario
				  })
			})
	},


	pre_insertar_otros(p_email, p_usuario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_garseguimiento.pre_insercion_otros",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario
				  })
			})
	},

	recuperar_sinliq(p_email, p_usuario, p_ejecutivo) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_garseguimiento.recuperar_sinliq",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_ejecutivo": p_ejecutivo
				  })
			})
	},

	noasigliq(p_email, p_usuario, p_siniestro) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_garseguimiento.noasigliq",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_siniestro": p_siniestro
				  })
			})
	},

	asigliq(p_email, p_usuario, p_siniestro) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_garseguimiento.asigliq",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_siniestro": p_siniestro
				  })
			})
	},

	recuperar_enproceso(p_email, p_usuario, p_ejecutivo) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_garseguimiento.recuperar_enproceso",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_ejecutivo": p_ejecutivo
				  })
			})
	},

	recuperar_liquidador(p_email, p_usuario, p_liquidador) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_garseguimiento.recuperar_liquidador",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_liquidador": p_liquidador
				  })
			})
	},

	recuperar_sincob(p_email, p_usuario, p_ejecutivo, p_ver) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_garseguimiento.recuperar_sincob",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_ejecutivo": p_ejecutivo,
					"p_ver": p_ver
				  })
			})
	},

	recuperar_otros(p_email, p_usuario, p_ejecutivo) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_garseguimiento.recuperar_otros",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_ejecutivo": p_ejecutivo
				  })
			})
	},


	asigcob(p_email, p_usuario, p_siniestro) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_garseguimiento.asigcob",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_siniestro": p_siniestro
				  })
			})
	},

	noasigcob(p_email, p_usuario, p_siniestro) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_garseguimiento.noasigcob",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_siniestro": p_siniestro
				  })
			})
	},

	
}